module.exports = __webpack_public_path__ + "static/line1_2-a8e3fe40ed35c17241da8e659939b19a.jpg";